export default __webpack_public_path__ + "static/media/default.43a291b4.png";